module.exports = __webpack_public_path__ + "static/media/right kneecap cartoon.c3f4503b.png";